import { useEffect, useState } from "react";
import { useWindowSize } from "./useWindowSize";

// Follows TailwindCss responsiveness guidelines
// https://tailwindcss.com/docs/responsive-design
const defaultSizesInPx = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export default function useMediaQuery() {
  const [minSize, setMinSizes] = useState({
    sm: false,
    md: false,
    lg: false,
    xl: false,
    "2xl": false,
  });

  const { width } = useWindowSize();

  useEffect(() => {
    const minSize = Object.keys(defaultSizesInPx).reduce((obj, key) => {
      obj[key] = defaultSizesInPx[key] < width;
      return obj;
    }, {});

    setMinSizes(minSize);
  }, [width]);

  return {
    ...minSize,
    isMobile: !minSize.sm,
    isTablet: minSize.md && !minSize.lg,
    isDesktop: minSize.lg,
  };
}
